<template>
  <div>
    <div>
      <div v-if="pageLoading" class="text-center" style="padding: 80px 0;">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Carregando...</span>
        </div>
        <p class="mt-2">Carregando modelos...</p>
      </div>

      <template v-else>
        <div class="d-flex justify-content-between align-items-center mb-1">
          <h3 class="mb-0">Modelos</h3>
          <router-link to="/product_models/add" class="btn btn-primary">Novo Modelo</router-link>
        </div>

        <div class="card crud-filters">
          <button
            type="button"
            class="btn-filters-toggle d-md-none"
            @click="filtersOpen = !filtersOpen"
          >
            <span>Filtros</span>
            <span class="chevron" :class="{ open: filtersOpen }">▾</span>
          </button>
          <div class="card-body" :class="{ 'card-body-mobile-open': filtersOpen }">
            <div class="row">
              <div class="col-md-4">
                <label>Nome do modelo</label>
                <input type="text" class="form-control" v-model="filters.name" placeholder="Buscar por nome...">
              </div>
              <div class="col-md-4">
                <label>Fabricante</label>
                <v-select
                  v-model="filters.manufacturer_id"
                  :options="manufacturers"
                  :reduce="(m) => m.id"
                  label="name"
                  placeholder="Selecione"
                ></v-select>
              </div>
              <div class="col-md-4">
                <label>Status</label>
                <v-select
                  v-model="filters.status"
                  :options="statusOptions"
                  :reduce="(s) => s.id"
                  label="text"
                  placeholder="Selecione"
                ></v-select>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-md-12">
                <button class="btn btn-primary" @click="applyFilters">Filtrar</button>
                <button class="btn btn-secondary ml-2" @click="clearFilters">Limpar filtros</button>
              </div>
            </div>
          </div>
        </div>

        <div class="card mt-0 crud-table-card">
          <div class="row" v-if="loading">
            <div class="col-md-12">
              <div class="text-center" style="padding: 50px;">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Carregando...</span>
                </div>
                <p class="mt-2">Carregando modelos...</p>
              </div>
            </div>
          </div>

          <div v-else class="table-responsive">
            <table class="table table-striped table-bordered table-hover crud-table">
              <thead>
                <tr>
                  <th @click="sortBy('id')" class="sortable">
                    ID
                    <i class="fas" :class="sortIconClass('id')"></i>
                  </th>
                  <th @click="sortBy('name')" class="sortable">
                    Modelo
                    <i class="fas" :class="sortIconClass('name')"></i>
                  </th>
                  <th>Fabricante</th>
                  <th @click="sortBy('status')" class="sortable">
                    Status
                    <i class="fas" :class="sortIconClass('status')"></i>
                  </th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!items.length">
                  <td colspan="5" class="text-center py-4">Nenhum registro encontrado</td>
                </tr>

                <tr v-for="item in items" :key="item.id">
                  <td data-label="ID">{{ item.id }}</td>
                  <td data-label="Modelo">{{ item.name }}</td>
                  <td data-label="Fabricante">
                    {{ item.manufacturer ? item.manufacturer.name : "-" }}
                  </td>
                  <td data-label="Status" class="text-center">
                    <span class="soft-badge" :class="item.status == 1 ? 'badge-success' : 'badge-secondary'">
                      {{ item.status == 1 ? "Ativo" : "Inativo" }}
                    </span>
                  </td>
                  <td data-label="Ações">
                    <router-link
                      :to="'/product_models/edit/' + item.id"
                      class="btn btn-crud edit margin-crud"
                      title="Editar"
                    >
                      <i class="fas fa-pencil-alt"></i>
                    </router-link>
                    <button
                      class="btn btn-crud delete margin-crud"
                      title="Deletar"
                      @click="destroy(item)"
                    >
                      <i class="far fa-trash-alt"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="pagination-bar">
            <div class="per-page-selector">
              Registros por página:
              <select class="form-control d-inline-block w-auto ml-1" v-model.number="pagination.perPage" @change="changePerPage">
                <option v-for="v in pagination.perPageOptions" :key="v" :value="v">{{ v }}</option>
              </select>
            </div>

            <div class="col-md-6 mt-1 mx-auto d-flex justify-content-center align-items-center">
              <pagination
                :records="totalItems"
                :options="paginationOptions"
                :per-page="pagination.perPage"
                @paginate="onPaginate"
              ></pagination>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { Pagination } from "vue-pagination-2";
import vSelect from "vue-select";

export default {
  components: {
    Pagination,
    vSelect,
  },
  data: function () {
    return {
      pageLoading: true,
      loading: false,
      filtersOpen: false,

      filters: {
        name: "",
        manufacturer_id: null,
        status: null,
      },

      statusOptions: [
        { id: 1, text: "Ativo" },
        { id: 0, text: "Inativo" },
      ],

      manufacturers: [],

      items: [],
      totalItems: 0,
      pagination: {
        page: 1,
        perPage: 10,
        perPageOptions: [10, 25, 50, 100],
      },
      paginationOptions: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
        chunk: 4,
        chunksNavigation: "fixed",
      },
      sort: {
        column: "id",
        ascending: false,
      },
    };
  },

  async mounted() {
    this.pageLoading = true;
    try {
      await Promise.all([this.getManufacturers(), this.fetchItems()]);
    } catch (e) {
      console.error(e);
    } finally {
      this.pageLoading = false;
    }
  },

  methods: {
    getManufacturers() {
      const self = this;
      return axios
        .get(self.$store.state.api + "manufacturers?paginated=false")
        .then((response) => {
          self.manufacturers = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    fetchItems() {
      const self = this;
      const f = this.filters;

      let qs = "";
      if (f.name) qs += "name=" + encodeURIComponent(f.name) + "&";
      if (f.manufacturer_id) qs += "manufacturer_id=" + f.manufacturer_id + "&";
      if (f.status !== null && f.status !== undefined) qs += "status=" + f.status + "&";

      qs += "with[]=manufacturer&";
      qs += "paginated=true&limit=" + this.pagination.perPage + "&page=" + this.pagination.page + "&";
      qs += (this.sort.ascending ? "orderByAsc=" : "orderByDesc=") + this.sort.column;

      self.loading = true;
      return axios
        .get(self.$store.state.api + "product_models?" + qs)
        .then((response) => {
          self.items = response.data.data;
          self.totalItems = response.data.count;
          self.loading = false;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.loading = false;
        });
    },

    applyFilters() {
      this.pagination.page = 1;
      this.fetchItems();
    },

    clearFilters() {
      this.filters = { name: "", manufacturer_id: null, status: null };
      this.applyFilters();
    },

    onPaginate(page) {
      this.pagination.page = page;
      this.fetchItems();
    },

    changePerPage() {
      this.pagination.page = 1;
      this.fetchItems();
    },

    sortBy(column) {
      if (this.sort.column === column) {
        this.sort.ascending = !this.sort.ascending;
      } else {
        this.sort.column = column;
        this.sort.ascending = true;
      }
      this.fetchItems();
    },

    sortIconClass(column) {
      if (this.sort.column !== column) return "fa-sort";
      return this.sort.ascending ? "fa-chevron-up" : "fa-chevron-down";
    },

    destroy(item) {
      const self = this;
      swal({
        title: "Deseja deletar o registro?",
        text: "Essa operação não pode ser desfeita",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, deletar!",
        showLoaderOnConfirm: true,
        buttons: {
          catch: { text: "Não", value: "cancel", className: "btn-danger" },
          confirm: { text: "Sim", value: "confirm" },
        },
      }).then((value) => {
        if (value !== "confirm") {
          swal("Cancelado", "O registro não foi excluído!", "info");
          return;
        }

        axios
          .delete(self.$store.state.api + "product_models/" + item.id)
          .then(() => {
            swal("Sucesso", "Registro excluído com sucesso!", "success");
            self.fetchItems();
          })
          .catch((error) => {
            self.$message(null, error.response.data, "error");
          });
      });
    },
  },
};
</script>

<style scoped>
.crud-table {
  margin-bottom: 0;
  font-size: 0.95rem;
  width: 100%;
  table-layout: fixed;
}

.crud-table thead th.sortable {
  cursor: pointer;
  user-select: none;
}

.crud-table td,
.crud-table th {
  padding: 0.9rem 0.75rem;
  white-space: normal;
  overflow-wrap: break-word;
}

.crud-table thead th {
  background-color: #283046 !important;
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
  vertical-align: middle;
  border-left: none !important;
  border-right: none !important;
  font-size: 0.80rem;
}

.crud-table tbody tr,
.crud-table tbody tr:nth-of-type(odd),
.crud-table tbody tr:nth-of-type(even) {
  background-color: #132133 !important;
}

.crud-table tbody td {
  background-color: #132133 !important;
}

.crud-table .soft-badge {
  display: inline-block;
  white-space: normal;
  padding: 0.5em 0.75em;
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.2;
  border-radius: 6px;
  border: 1px solid transparent;
}

.crud-table .soft-badge.badge-success {
  background-color: rgba(40, 199, 111, 0.12) !important;
  border-color: rgba(40, 199, 111, 0.4);
  color: #5cb98a !important;
}

.crud-table .soft-badge.badge-secondary {
  background-color: rgba(130, 134, 139, 0.12) !important;
  border-color: rgba(130, 134, 139, 0.4);
  color: #a9adb3 !important;
}

.crud-table td:last-child {
  text-align: center;
  white-space: nowrap;
}

.margin-crud {
  margin: 0 2px;
}

.pagination-bar {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 16px;
  position: relative;
}

.pagination-bar .per-page-selector {
  position: absolute;
  left: 16px;
  top: 16px;
  display: flex;
  align-items: center;
  height: 38px;
}

.pagination-bar ::v-deep .VuePagination {
  text-align: center;
  margin-bottom: 0;
}

.pagination-bar ::v-deep .VuePagination ul.pagination {
  margin-bottom: 0;
  justify-content: center;
}

.pagination-bar ::v-deep .VuePagination__count {
  margin: 8px 0 0;
}

.crud-filters,
.crud-table-card {
  background: rgba(23, 38, 57, 0.55) !important;
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.05);
}
.crud-filters {
  position: relative;
  z-index: 20;
}

.crud-table-card {
  position: relative;
  z-index: 1;
  border-radius: 6px;
  overflow: hidden;
}

.btn-filters-toggle {
  display: none;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  background: transparent;
  border: none;
  color: inherit;
  font-weight: 600;
  font-size: 14px;
  padding: 14px 16px;
  cursor: pointer;
}
.btn-filters-toggle .chevron {
  transition: transform .15s;
  color: rgba(255,255,255,.5);
}
.btn-filters-toggle .chevron.open { transform: rotate(180deg); }

/* LIGHT MODE */

body:not(.dark-layout) .crud-page-container {
  background-color: #eef1f6;
}

body:not(.dark-layout) .crud-filters,
body:not(.dark-layout) .crud-table-card {
  background: rgba(255, 255, 255, 0.55) !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.12),
    inset 0 1px 0 rgba(255, 255, 255, 0.6);
}

body:not(.dark-layout) .crud-table thead th {
  background-color: rgba(255, 255, 255, 0.45) !important;
}

body:not(.dark-layout) .crud-table tbody tr,
body:not(.dark-layout) .crud-table tbody tr:nth-of-type(odd),
body:not(.dark-layout) .crud-table tbody tr:nth-of-type(even),
body:not(.dark-layout) .crud-table tbody td {
  background-color: rgba(255, 255, 255, 0.35) !important;
}

body:not(.dark-layout) .crud-table .soft-badge.badge-success { color: #28c76f !important; }
body:not(.dark-layout) .crud-table .soft-badge.badge-secondary { color: #82868b !important; }

/* RESPONSIVO — MOBILE */

@media (max-width: 768px) {
  .btn-filters-toggle { display: flex; }
  .crud-filters .card-body { display: none; }
  .crud-filters .card-body.card-body-mobile-open { display: block; padding-top: 0; }

  .crud-table thead { display: none; }
  .crud-table, .crud-table tbody, .crud-table tr, .crud-table td {
    display: block;
    width: 100% !important;
  }
  .crud-table tr {
    margin-bottom: 14px;
    border-radius: 8px;
    padding: 14px;
    border: 1px solid rgba(255,255,255,.08);
  }

  .crud-table td[data-label]::before {
    content: attr(data-label);
    display: block;
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: .3px;
    text-transform: uppercase;
    color: rgba(255,255,255,.45);
    margin-bottom: 4px;
  }
  .crud-table td[data-label] {
    text-align: left !important;
  }

  .crud-table td:last-child .btn {
    display: inline-block;
    margin: 4px 6px 0 0;
  }

  body:not(.dark-layout) .crud-table td[data-label]::before {
    color: rgba(0,0,0,.45);
  }

  .pagination-bar {
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding-top: 5px;
  }
  .pagination-bar .per-page-selector {
    position: static;
    justify-content: center;
    width: 100%;
  }
  .pagination-bar ::v-deep .VuePagination__count {
    font-size: 12px;
    text-align: center;
  }

  .crud-filters .row.mt-3 > .col-md-12 {
    display: flex;
    flex-wrap: nowrap;
    gap: 8px;
  }
  .crud-filters .row.mt-3 .btn {
    flex: 1 1 0;
    margin-left: 0 !important;
    white-space: nowrap;
  }
}
</style>
